import React from 'react'
import strings from 'strings'

/** Open / All / Completed chips at the top of the list. */
const TaskFilters = ({ filter, setFilter, counts }) => {
    const t = strings.CT
    const all = (counts?.open || 0) + (counts?.completed || 0)
    const chips = [
        { key: 'open', label: t.FILTER_OPEN, count: counts?.open || 0 },
        { key: 'all', label: t.FILTER_ALL, count: all },
        { key: 'completed', label: t.FILTER_COMPLETED, count: counts?.completed || 0 }
    ]
    return (
        <div className="ct-filters">
            {chips.map(chip => (
                <button
                    key={chip.key}
                    className={`ct-filter-chip ${filter === chip.key ? 'active' : ''}`}
                    onClick={() => setFilter(chip.key)}
                >
                    {chip.label}
                    <span className="ct-filter-count">{chip.count}</span>
                </button>
            ))}
            <div className="ct-sort">
                {t.SORT_LABEL} <strong>{t.SORT_MOST_RECENT}</strong>
            </div>
        </div>
    )
}

export default TaskFilters
